import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)/management")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
